import * as React from 'react'
import * as styles from './Summary.module.scss'
import * as cn from 'classnames'
import { Text } from '@amzn/dvui/dist/Text'
import { DVString } from '@utils'

export const Summary = ({ title, synopsis }: { title?: string, synopsis?: string | DVString }) => (
    <div className={styles.summary}>
        <h1 className={cn(styles.title, 'tst-hover-title')}>
            {title}
        </h1>
        <Text className={cn(styles.synopsis, 'tst-hover-synopsis')} tag={'p'}>
            {synopsis}
        </Text>
    </div>
)